module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/modules/_function-to-string.js
// module id = 314
// module chunks = 128